@value columnWidth as cardWidth from '../../visual-pipeline/column/visual-pipeline-column.module.css';

.card-container {
    width: cardWidth;
    transform: rotate(5deg);
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.3);
    border-radius: 3px;
}
